// @flow
import { css } from 'styled-components';

export const FONT_WEIGHT_700 = css`
  font-weight: 700;
`;

export const FONT_WEIGHT_400 = css`
  font-weight: 400;
`;

export const FONT_WEIGHT_100 = css`
  font-weight: 100;
`;



// WEBPACK FOOTER //
// ./src/styles/font-weight.js